<template>
    <ContentPage title="Comisiones - Vendedor">
        <div>
            <p>
                Salvo acuerdo escrito en contrario o indicación diferente en las Condiciones particulares de subasta, las Comisiones que el Vendedor
                debe pagar a Fleequid por la compraventa de cada vehículo individual realizada a través del Marketplace o de los servicios y sistemas
                de compraventa de Fleequid son las siguientes:
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> sin IVA</p>
            <p><strong>**</strong> más IVA si corresponde</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Ejemplo 1:</p>
            <p>Precio de adjudicación: 6.000&nbsp;€ +&nbsp;IVA</p>
            <p>
                Comisión a pagar a Fleequid por el Vendedor: <br class="md:hidden" />
                <span class="font-medium">
                    importe fijo de 250&nbsp;€ +&nbsp;(6.000&nbsp;€ * 8,75%) =
                    <span class="whitespace-nowrap">775&nbsp;€ +&nbsp;IVA</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Ejemplo 2:</p>
            <p>Precio de adjudicación: 180.000&nbsp;€ +&nbsp;IVA</p>
            <p>
                Comisión a pagar a Fleequid por el Vendedor: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(100.000&nbsp;€ * 8,75%) +&nbsp;(80.000&nbsp;€ * 3,75%) =
                    <span class="whitespace-nowrap">12.000&nbsp;€ +&nbsp;IVA</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
